'use strict';
import * as $j_app$002eapi$002e$002dGeneral$002dPractice$002dUser$002dFull$002dReference from "./app.api.-General-Practice-User-Full-Reference.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$38(evaluator$26) {
  this.Lapp_api_DrugRequestsAcceptedListItem$$anon$38__f_evaluator$6 = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$$anon$38__f_evaluator$6 = evaluator$26;
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$38 as $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$38 };
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$38.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$38.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$38;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$38() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$38 as $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$38 };
$h_Lapp_api_DrugRequestsAcceptedListItem$$anon$38.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$38.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$38.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$38.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_DrugRequestsAcceptedListItem$$anon$38__f_evaluator$6.apply__O();
  return ((v instanceof $j_app$002eapi$002e$002dGeneral$002dPractice$002dUser$002dFull$002dReference.$c_Lapp_api_GeneralPracticeUserFullReference) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$38.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$38 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$$anon$38, "app.api.DrugRequestsAcceptedListItem$$anon$38", ({
  Lapp_api_DrugRequestsAcceptedListItem$$anon$38: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$38 as $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$38 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$$anon$38.js.map
